import {
    MarketProductProgress,
    MotivationGroup,
    Product,
    ProductPlanExtended,
} from "tm-shared/types";

import { AdvancedProduct } from "../SalePage.types";

export const makeAdvancedProducts = (
    products: Product[],
    specialKPIGroups: MotivationGroup[],

    plan: {
        [barcode: string]: ProductPlanExtended;
    },
    adittionalPlan: {
        [barcode: string]: ProductPlanExtended;
    },
    facts: {
        [barcode: string]: MarketProductProgress;
    },
    priceList: Record<
        string,
        {
            barcode: string;
            discount: number;
            firstPrice: number;
            isPersonalPrice: boolean;
            oldPrice: number;
            price: number;
        }
    >,
    mmlList: Record<string, boolean>,
): AdvancedProduct[] => {
    const checkIsSpecialTask = (
        finGroup?: string,
    ): "default" | "dropout" | null => {
        if (!finGroup) return null;

        const group = specialKPIGroups.find(({ finGroups }) =>
            finGroups.includes(finGroup),
        );

        if (!group) return null;

        return group.motivationType === "s" ? "dropout" : "default";
    };

    return products.map(({ name, barcode, params }) => {
        const finGroup = params?.fin_group_detail?.value;
        const isNew = params?.new?.value;

        return {
            name,
            barcode,
            price: priceList?.[barcode]?.price,
            oldPrice: priceList?.[barcode]?.oldPrice,
            isPersonalPrice: priceList?.[barcode]?.isPersonalPrice,
            isNew,
            isMML: mmlList[barcode],
            isSpecialTask: checkIsSpecialTask(finGroup),
            productPlan:
                plan[barcode]?.stage === "out_of_plan"
                    ? null
                    : plan[barcode]?.type || null,
            additionalPlan:
                adittionalPlan[barcode]?.stage === "out_of_plan"
                    ? null
                    : adittionalPlan[barcode]?.type || null,
            productFact: facts?.[barcode] || null,
        };
    });
};
